import React from 'react';
import { withRouter } from 'react-router';

import IconButton from '@material-ui/core/IconButton';

import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';

//Part
import DialogHelp from './DialogHelp';



class Comp extends React.Component {

  _back() {
    if(this.props.history.action === "PUSH") {
      this.props.history.goBack();
    }
    else {
      this.props.history.push(this.props.onback);
    }
  }

  render() {
  	return (
      <div
        style={{
          display:'flex',
          flexDirection:'row',
          textAlign:'center',
          alignItems:'center',
          justifyContent:'space-between',
        }}
      >
        <div style={{width:'50px'}}>
          {
            (this.props.onback) && (
              <IconButton onClick={ () => this._back() }>
                <ArrowBackIosIcon />
              </IconButton>
            )
          }
        </div>
        <h1>
          {this.props.title}
        </h1>
        <div style={{width:'50px'}}>
          {
            (this.props.helpType && this.props.helpFilter) && (
              <DialogHelp
                type={this.props.helpType}
                filter={this.props.helpFilter}
              />
            )
          }
        </div>
      </div>
  	)
  }
}

export default withRouter(Comp);
